"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDrillIntersection = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var tableDescriptorTypes_1 = require("../structure/tableDescriptorTypes");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var colDrillHeadersFactory_1 = require("./colDrillHeadersFactory");
/**
 * Given an ag-grid cell event and table descriptor, create a drill intersection that exactly describes
 * coordinates of the clicked cell - by using attribute element headers, attribute descriptors and optionally measure
 * descriptor.
 *
 * @param cellEvent - cell event from ag-grid
 * @param tableDescriptor - table descriptor
 */
function createDrillIntersection(cellEvent, tableDescriptor) {
    var mappingHeaders = [];
    var col = tableDescriptor.getCol(cellEvent.colDef);
    var row = cellEvent.data;
    ts_invariant_1.default(tableDescriptorTypes_1.isSliceCol(col) || tableDescriptorTypes_1.isSeriesCol(col));
    if (tableDescriptorTypes_1.isSeriesCol(col)) {
        mappingHeaders.push.apply(mappingHeaders, colDrillHeadersFactory_1.createDataColLeafHeaders(col));
    }
    var effectiveSliceCols = tableDescriptor.getSliceColsUpToIncludingCol(col);
    effectiveSliceCols.forEach(function (col) { return mappingHeaders.push.apply(mappingHeaders, colDrillHeadersFactory_1.createSliceColHeaders(col, row)); });
    return sdk_ui_1.getDrillIntersection(mappingHeaders);
}
exports.createDrillIntersection = createDrillIntersection;
//# sourceMappingURL=drillIntersectionFactory.js.map